import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import TemplateRenderer from "../components/TemplateRenderer";

export default function Preview() {
  const { id } = useParams();
  const [inv, setInv] = useState(null);

  useEffect(() => {
    api.get(`/invitations/${id}`).then((r) => setInv(r.data));
  }, [id]);

  if (!inv) return <div className="min-h-screen flex items-center justify-center text-stone-500">Loading...</div>;

  return (
    <div data-testid="preview-page">
      <div className="fixed top-4 left-4 z-50 flex gap-2">
        <Link to={`/editor/${id}`} className="px-4 py-2 bg-white border border-stone-300 text-xs uppercase tracking-[0.2em] hover:bg-stone-100" data-testid="back-to-editor">← Edit</Link>
        <Link to={`/i/${inv.slug}`} target="_blank" rel="noreferrer" className="px-4 py-2 bg-emerald-600 text-white text-xs uppercase tracking-[0.2em] hover:bg-emerald-700" data-testid="preview-public-link">Open Public Link ↗</Link>
      </div>
      <TemplateRenderer templateId={inv.template_id} data={inv.data} slug={null} isPreview />
    </div>
  );
}
